













































import { Vue, Component, Prop } from "vue-property-decorator";
import { RouteConfig } from "vue-router";
@Component
export default class MainMenu extends Vue {
  @Prop({ default: false }) private collapse!: boolean;
  get visibleRoutes(): Array<RouteConfig> {
    return this.$router.options.routes || [];
  }
  private handleSelectMenu(index: string) {
    this.$router.push(index);
  }
  private collapseMenu(isCollapse: boolean) {
    this.$emit("update:collapse", isCollapse);
  }
}
